<div class="row no-gutters">
    <div id="filter-bg" class="bg-change" [ngClass]="iconsExpanded ? 'showed': ''" ></div>
    <div class="col">
        <div class="section-icons-container">
            <div class="status-filter" *ngIf="showSearch">
                <div class="status-pick">
                    <input class="status-checkbox" type="checkbox" [(ngModel)]="statusActive"
                        [ngModelOptions]="{standalone: true}" (change)="statusChange()" />
                    <div class="status-text">Active</div>
                </div>
                <div class="status-pick">
                    <input class="status-checkbox" type="checkbox" [(ngModel)]="statusArchived"
                        [ngModelOptions]="{standalone: true}" (change)="statusChange()" />
                    <div class="status-text">Archived</div>
                </div>
                <div class="filter-help">
                    <apc-help-icon text="buttons.help.filterHelp">
                    </apc-help-icon>
                </div>
            </div>
            <div *ngIf="enableFilter && !isAdministration" class="icon" [class.whiteBg]="showSearch"
                (click)="!showSearch ? displaySearchEvent.emit(true) : clearSearchEvent.emit(true)"
                [ngbTooltip]="!showSearch ? translate.instant('buttons.filter')  : translate.instant('buttons.clearFilter')"
                tooltipClass="animation-tooltip" placement="top" container="body" triggers="hover">
                <div>
                    <img [src]="!showSearch ? 'assets/ico/filter.svg' : 'assets/ico/clear-button.svg'"
                        alt="!showSearch ? translate.instant('buttons.filter')  : translate.instant('buttons.clearFilter')">
                </div>
            </div>
            <div *ngIf="enableFilter" class="icon" (click)="columnFilter = !columnFilter"
                (clickOutside)="onClickedOutside($event)" [ngbTooltip]="translate.instant('buttons.columnsFilter')"
                tooltipClass="animation-tooltip" placement="top" container="body" triggers="hover">
                <div>
                    <img [src]="'assets/ico/sliders-h-solid.svg'" alt="translate.instant('buttons.columnsFilter')">
                </div>
            </div>
            <div class="buttons-dropdown">
                <div *ngIf="iconsExpanded" id="close-export-dropdown" class="icon mt-2 expanded-icon close-icon" [ngStyle]="{'opacity' : iconsExpanded ? 1 : 0}"
                    (click)="iconsExpanded = false;"
                    [ngbTooltip]="translate.instant('buttons.close')" tooltipClass="animation-tooltip" placement="top"
                    container="body" triggers="hover">
                    <div>
                        <img [src]="'assets/ico/close-black.svg'" alt="translate.instant('buttons.close')">
                    </div>
                </div>
                <div class="icon" (click)="showExportOptions()" [ngbTooltip]="translate.instant('buttons.exportData')"
                    tooltipClass="animation-tooltip" placement="top" container="body" triggers="hover">
                    <div>
                        <img [src]="'assets/ico/download.svg'" alt="translate.instant('buttons.eportData')">
                    </div>
                </div>
                <div class="icon mt-2 expanded-icon"  [ngClass]="iconsExpanded ? 'showed': ''" 
                    (click)="exportCSVEvent.emit(true)" [ngbTooltip]="translate.instant('buttons.exportCSV')"
                    tooltipClass="animation-tooltip" placement="top" container="body" triggers="hover">
                    <div>
                        <img [src]="'assets/ico/csv.svg'" alt="translate.instant('buttons.exportCSV')">
                    </div>
                </div>
    

                <!--    <apc-sheet-export (exportSheetEvent)="exportSheetEvent.emit(true);" (getToken)="getTokenClient($event)"[expanded]="iconsExpanded" [ngClass]="iconsExpanded ? 'showed': ''"  >
                    </apc-sheet-export>-->
        

                
                

                <div  [ngClass]="iconsExpanded ? 'showed': ''"   class="icon mt-2 expanded-icon"
                    (click)="copyToClipboardEvent.emit(true)"
                    [ngbTooltip]="translate.instant('buttons.copyToClipboard')" tooltipClass="animation-tooltip"
                    placement="top" container="body" triggers="hover">
                    <div>
                        <img [src]="'assets/ico/copy-regular-black.svg'"
                            alt="translate.instant('buttons.copyToClipboard')">
                    </div>
                </div>
            </div>



            <div class="icon" (click)="refreshDataEvent.emit(true)"
                [ngbTooltip]="translate.instant('buttons.refreshData')" tooltipClass="animation-tooltip" placement="top"
                container="body" triggers="hover">
                <div>
                    <img [src]="'assets/ico/refresh-icon.svg'" alt="translate.instant('buttons.refreshData')">
                </div>
            </div>

        </div>
    </div>
</div>

<div *ngIf="columnFilter" class="column-filter-select">
    <ng-select [multiple]="true" [ngModel]="selectedTableColumns" (change)="selectTableColumnsEvent.emit($event)"
        [items]="columnsToDisplayInDropdown" [dropdownPosition]="'bottom'" [closeOnSelect]="false"
        [isOpen]="columnFilter" class="column-display">
        <ng-template ng-header-tmp>
            <div class="select-utils">
                <span (click)="selectAllColumnsEvent.emit(true)">{{'columnName.selectAll' | translate}}</span> | <span
                    (click)="unselectAllColumnsEvent.emit(true)">{{'columnName.selectNone' | translate}}</span>
                | <span (click)="defaultColumnsEvent.emit(true)">{{'columnName.default' | translate}}</span>
            </div>
        </ng-template>
        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index" class="option column-options">
            <div isEllipsisActive class="dropdown-select-wrapper" style="height: 20px !important; margin-top: -6px;">
                <input style="height: 11px;" id={{item.name}} type="checkbox" [ngModel]="item.selected" />&nbsp;
                <span style="max-width: 290px; font-size: 14px;" class="dropdown-select-label">{{'columnName.' +
                    item.name | translate }}</span>
            </div>
        </ng-template>
    </ng-select>
</div>